import { useDisclosure } from "@mantine/hooks";
import { Suspense } from "react";

import { PartDto } from "#modules/parts/infra/fetchPart.api";
import { SearchSimilarPartDto } from "#modules/similarPart/infra/searchSimilarParts.api";
import { safeLazy } from "#shared/helpers/safeLazy";
import { Loader } from "#shared/view/components/Loader";

import { PartCard } from "./PartCard";

const ResultModal = safeLazy(() =>
  import("#modules/similarPart/view/ResultModal/ResultModal").then((mod) => ({
    default: mod.ResultModal,
  })),
);

type Props = {
  targetPart: SearchSimilarPartDto & { cosineSimilarity?: number };
  sourcePart?: PartDto;
  featuresDisplayMode?: "truncate" | "all" | "none";
  displayScore?: boolean;
  index: number;
};

export const ResultPartCard = ({
  targetPart,
  sourcePart,
  featuresDisplayMode,
  displayScore,
  index,
}: Props) => {
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      {opened && (
        <Suspense fallback={<Loader />}>
          <ResultModal
            onClose={close}
            opened={opened}
            index={index}
            targetPart={targetPart}
            sourcePart={sourcePart}
          />
        </Suspense>
      )}
      <PartCard
        onClick={open}
        part={targetPart}
        featuresDisplayMode={featuresDisplayMode || "truncate"}
        enable3DViewer={false}
        displayScore={displayScore}
        sourcePartId={sourcePart?.id}
        index={index}
      />
    </>
  );
};
